import { Schema } from "effect";

export const MessageEmailType = Schema.Literal("gmail", "outlook");
export type MessageEmailType = typeof MessageEmailType.Type;

export const MessageEmailAddressType = Schema.Literal(
  "from",
  "to",
  "cc",
  "bcc",
);
export type MessageEmailAddressType = typeof MessageEmailAddressType.Type;

export const EmailAddressEntry = Schema.Struct({
  addressType: MessageEmailAddressType,
  email: Schema.String.pipe(Schema.minLength(1)),
  name: Schema.NullOr(Schema.String),
});
export type EmailAddressEntry = typeof EmailAddressEntry.Type;

import type { MessageResponse } from "../message";

export type EmailMessage = Extract<MessageResponse, { channel: "email" }>;

export const isEmailMessage = (
  message: MessageResponse,
): message is EmailMessage => {
  return message.channel === "email";
};
